(function () {
  function initProductTip() {
    var productHeader = document.querySelector('.product-tip-header');
    var productContent = document.querySelector('.product-tip-content');

    if (!productHeader || !productContent || productHeader.dataset.tipReady === 'true') return;

    productHeader.dataset.tipReady = 'true';
    productHeader.addEventListener('mouseenter', function () {
      productContent.style.display = 'block';
    });
    productHeader.addEventListener('mouseleave', function () {
      productContent.style.display = 'none';
    });
  }

  function panelFor(root, panelName) {
    var panels = root.querySelectorAll('[data-hibana-panel]');
    for (var i = 0; i < panels.length; i += 1) {
      if (panels[i].getAttribute('data-hibana-panel') === panelName) return panels[i];
    }
    return null;
  }

  function activePanel(root) {
    return root.querySelector('[data-hibana-panel].is-active');
  }

  function resetMenu(root) {
    var panels = root.querySelectorAll('[data-hibana-panel]');
    var triggers = root.querySelectorAll('[data-hibana-panel-open]');

    root._hibanaPanelStack = [];

    for (var i = 0; i < panels.length; i += 1) {
      var isMain = panels[i].getAttribute('data-hibana-panel') === 'main';
      panels[i].classList.toggle('is-active', isMain);
      panels[i].classList.remove('is-behind');
      panels[i].setAttribute('aria-hidden', isMain ? 'false' : 'true');
    }

    for (var j = 0; j < triggers.length; j += 1) {
      triggers[j].setAttribute('aria-expanded', 'false');
    }
  }

  function prepareMenu(root) {
    if (!root || root.dataset.hibanaReady === 'true') return;

    var drawer = root.closest('#t4s-menu-drawer');
    root.dataset.hibanaReady = 'true';
    root._hibanaPanelStack = [];

    if (drawer) {
      drawer.classList.add('hibana-mobile-drawer');
      var style = root.getAttribute('style') || '';
      drawer.setAttribute('style', (drawer.getAttribute('style') || '') + style);
    }

    resetMenu(root);
  }

  function prepareMenus(scope) {
    var roots = (scope || document).querySelectorAll('[data-hibana-mobile-nav]');
    for (var i = 0; i < roots.length; i += 1) prepareMenu(roots[i]);
    initProductTip();
  }

  function openPanel(trigger) {
    var root = trigger.closest('[data-hibana-mobile-nav]');
    if (!root) return;

    prepareMenu(root);

    var current = activePanel(root);
    var next = panelFor(root, trigger.getAttribute('data-hibana-panel-open'));
    if (!current || !next || current === next) return;

    if (!Array.isArray(root._hibanaPanelStack)) root._hibanaPanelStack = [];
    root._hibanaPanelStack.push({ panel: current, trigger: trigger });

    current.classList.remove('is-active');
    current.classList.add('is-behind');
    current.setAttribute('aria-hidden', 'true');
    next.classList.remove('is-behind');
    next.classList.add('is-active');
    next.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');

    window.setTimeout(function () {
      var focusTarget = next.querySelector('[data-hibana-panel-back], a, button');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }, 20);
  }

  function goBack(root) {
    if (!root || !Array.isArray(root._hibanaPanelStack) || root._hibanaPanelStack.length === 0) return false;

    var current = activePanel(root);
    var previousState = root._hibanaPanelStack.pop();

    if (current) {
      current.classList.remove('is-active', 'is-behind');
      current.setAttribute('aria-hidden', 'true');
    }

    previousState.panel.classList.remove('is-behind');
    previousState.panel.classList.add('is-active');
    previousState.panel.setAttribute('aria-hidden', 'false');
    previousState.trigger.setAttribute('aria-expanded', 'false');

    window.setTimeout(function () {
      previousState.trigger.focus({ preventScroll: true });
    }, 20);

    return true;
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-hibana-panel-open]');
    if (openTrigger) {
      event.preventDefault();
      openPanel(openTrigger);
      return;
    }

    var backTrigger = event.target.closest('[data-hibana-panel-back]');
    if (backTrigger) {
      event.preventDefault();
      goBack(backTrigger.closest('[data-hibana-mobile-nav]'));
      return;
    }

    if (event.target.closest('[data-drawer-close]')) {
      var openRoots = document.querySelectorAll('[data-hibana-mobile-nav]');
      for (var i = 0; i < openRoots.length; i += 1) resetMenu(openRoots[i]);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var drawer = document.querySelector('#t4s-menu-drawer[aria-hidden="false"]');
    var root = drawer && drawer.querySelector('[data-hibana-mobile-nav]');
    if (root && goBack(root)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    prepareMenus(event.target);
  });

  prepareMenus(document);

  if (document.body && 'MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        for (var j = 0; j < mutations[i].addedNodes.length; j += 1) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1) prepareMenus(node.matches('[data-hibana-mobile-nav]') ? node.parentNode : node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
